<template>
  <div>
    <center>
      <v-progress-circular v-if="loading" indeterminate color="primary"></v-progress-circular>
      <h1>All Incidents</h1>
       <p>Click on incident to view details</p>
    </center>
    <div id="incidentsViewer">
       <hr>
       <v-btn @click="goBack()" class="ma-2" color="primary" text><v-icon darkleft>mdi-arrow-left</v-icon>BACK</v-btn>
       <v-btn @click="getIncidents()" class="ma-2" color="primary" text><v-icon darkleft>mdi-refresh</v-icon>REFRESH</v-btn>
      <center>
      </center>
      <div v-for="incident in incidents" v-bind:key="incident.incidentID" class="watchlistItems">
          <router-link style="text-decoration: none; color: inherit;" :to="{path: 'incident', query: {incidentID: incident.incidentID}}">
          <h2>{{ incident.type }}</h2>
          <p>{{ incident.address }}</p>
          <p>{{ incident.municipality }}</p>
          <p>{{ incident.time_created }}</p>
        </router-link>
        <hr>
      </div>
    </div>
    <v-snackbar :color="snackbar.color" v-model="snackbar.show" timeout="3000">
      {{ snackbar.message }} 
      <v-btn text @click="snackbar.show = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    incidents: [],
    servicesArray: [],
    areaSupported: [],
    areaIDarray: [],
    selectedService: "All",
    selectedArea: null,
    dateSelected: "2021-01-16",
    minDate: "2021-01-02",
    maxDate: "2021-01-16",
    viewIncidents: false,
    viewSelector: true,
    snackbar: {
      show: false,
      message: null,
      color: "primary",
    }
  }),
  name: 'App',

  components: {
  },

  async created(){
    if (!localStorage.username){
      localStorage.removeItem('token');
      this.$router.push('login');
      return
    }
    window.scrollTo(0,0);
    this.getIncidents();

  },
  methods: {
    error(message){
      this.snackbar.show = true;
      this.snackbar.message = message;
      this.snackbar.color = "error";
    },
    goBack(){
      history.back();
    },
    async getIncidents(){
      this.loading = true;

      if (!this.$route.query.area){
        this.$router.push({path: 'all-incidents-search'});
        return
      }
      const areaID = this.$route.query.area

      if (!this.$route.query.date){
        this.$router.push({path: 'all-incidents-search'});
        return
      }
      let dateSelected = this.$route.query.date

      if (!this.$route.query.service){
        this.$router.push({path: 'all-incidents-search'});
        return
      }
      const selectedService = this.$route.query.service
      
      if (dateSelected == 'today'){
          const today = new Date();
          const dateDay = String(today.getDate()).padStart(2, "0");
          const dateMonth = String(today.getMonth() + 1).padStart(2, "0");
          const dateYear = today.getFullYear();

          dateSelected = dateYear + '-' + dateMonth + '-' + dateDay;
      }
      const incidentsResponse = await fetch(`${localStorage.apiURL}/app/incidents/${areaID}/${dateSelected}/${selectedService}`, {
        method: "GET",
        headers: {"deviceID": localStorage.token, "tokenID": localStorage.tokenID}
      });

      if (!incidentsResponse.ok){
        this.loading = false;
        this.error(`Returned a ${incidentsResponse.status}`);
        return;
      }

      const incidentsData = await incidentsResponse.json();

      if (!incidentsData.success){
        this.loading = false;
        this.error(`an error occured '${incidentsData.msg}'`);
        return
      }

      if (incidentsData.incidents.length === 0){
        this.loading = false;
        this.error("No incidents found")
      }
      this.incidentsData = null;
      this.incidents = incidentsData.incidents;
      this.viewSelector = false;
      this.viewIncidents = true;
      this.loading = false;
      }
  },
};
</script>

<style scoped>
.watchlistItems{
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 10px;
}
.watchlistItems:hover{
  background-color: rgb(209, 209, 209);
}

p{
  margin: 0;
}
.selectors{
  margin-top: 35px;
  width: 350px;
}
.calendar{
  margin-top: 50px;
}
#continueButton{
  margin-bottom: 10%;
}

</style>
